import apiClient from "config/apiClient";
import { DEFAULT_LIMIT_ITEMS } from "constants/data";
import { toSnakeCase } from "util/helper";
import { PaginationParamType } from "type";
import Notify from "config/notify";
import { Category } from "../types";

export interface CategoryQuery extends PaginationParamType {
  id?: number;
  categoryCd?: string;
  categoryKbn?: string;
  categoryKbnCd?: string;
  categoryName?: string;
  statusFlag?: number;
}

interface ResponseCompanyList {
  list: Category[];
  total: number;
}

/**
 *  get company list
 * @param body CompanyQuery
 */
export default async function getCategoryListApi(
  body?: CategoryQuery,
): Promise<ResponseCompanyList> {
  const res = await apiClient.post<ResponseCompanyList>(
    `/mst/category/select`,
    toSnakeCase({
      limit: body?.limit || DEFAULT_LIMIT_ITEMS,
      offset: body?.offset || 1,
      ...(body?.categoryCd && { categoryCd: body?.categoryCd }),
      ...(body?.categoryKbn && { categoryKbn: body?.categoryKbn }),
      ...(body?.categoryName && { categoryName: body?.categoryName }),
      ...(body?.categoryKbnCd && { categoryKbnCd: body?.categoryKbnCd }),
      ...(body?.statusFlag && { statusFlag: body?.statusFlag }),
      ...(body?.id && { id: body?.id }),
    }),
  );
  return { list: res.data?.list || [], total: res.data?.total || 0 };
}

export interface CategoryUpdateRequest {
  id: number;
  categoryCd: string;
  categoryKbnCd: string;
  categoryKbn: string;
  categoryName: string;
  seq: number;
  statusFlag: number;
  deleteFlag: number;
}

/**
 * Updates a category using the provided request body.
 * @param {CategoryUpdateRequest} body - The request body containing the category update details.
 * @returns {Promise<void>} A promise that resolves when the category update is complete.
 */
export const updateCategoryApi = async (body: CategoryUpdateRequest): Promise<void> => {
  const response = await apiClient.post(`/mst/category/update`, toSnakeCase(body));
  if (response.status === 200) {
    Notify.setNotification({
      show: true,
      title: "更新が完了しました",
      confirmLabel: "OK",
      actionsPosition: "end",
    });
  }
};

export interface CategoryCreateRequest {
  categoryCd: string;
  categoryKbnCd: string;
  categoryKbn: string;
  categoryName: string;
  seq: number;
  statusFlag: number;
  deleteFlag: number;
}

/**
 * Creates a new category using the provided request body.
 * @param {CategoryCreateRequest} body - The request body containing the category details.
 * @returns {Promise<void>} A promise that resolves when the category creation is complete.
 */
export const createCategoryApi = async (body: CategoryCreateRequest): Promise<void> => {
  const response = await apiClient.post(`/mst/category/create`, toSnakeCase(body));
  if (response.status === 200) {
    Notify.setNotification({
      show: true,
      title: "新規登録しました",
      confirmLabel: "OK",
      actionsPosition: "end",
    });
  }
};
